<!-- 医生建议 -->
<template>
  <div>
    <van-cell>
      <div class="title" slot="title">
        疾病名称
      </div>
      <div class="value">
        {{ info.cloudIll.illName }}
      </div>
    </van-cell>
    <van-cell>
      <div slot="title" class="title">
        病情描述
      </div>
    </van-cell>
    <van-cell :value="info.cloudIll.illDescribe" :class="value"> </van-cell>
    <div class="imgs">
      <div class="imgBox" v-for="(v, k) in info.list" :key="k">
        <div class="img">
          <van-image
            class="img1"
            :src="`${serviceUrl}/api/authex/cloudClinic/loadImageFile?orgId=15&userId=${info.cloudIll.regUserId}&fileId=${v.fileId}`"
            @click="showImg(k)"
          >
          </van-image>
        </div>
      </div>
    </div>
    <div>
      <div v-if="mzksdm==108||mzksdm==145">
        <!--感染科问卷 肿瘤科问卷--->
        <grkQuestionView :grkQuestion="grkQuestion"></grkQuestionView>
      </div>

      <div v-if="mzksdm==4152">
        <!--儿童保健科门诊--->
        <childQuestionView :question="childQuestion"></childQuestionView>
      </div>
      <div v-if="mzksdm==141">
        <!--呼吸科  --->
        <puffQuestionView :question="puffQuestion"></puffQuestionView>
      </div>
      <div v-if="mzksdm==4178">
        <!--产科--->
        <obstetricsQuestionView :question="obstetricsQuestion"></obstetricsQuestionView>
      </div>
    </div>
    <!-- <van-cell style="margin-top:10px">
      <div class="title">治疗建议</div>
    </van-cell>
    <van-field
      class="ms"
      :disabled="info.cloudIll.visitState == 7"
      style="color:#333;font-size:12px;margin-bottom:10px"
      rows="3"
      :error-message="errMsg"
      autosize
      id="textarea"
      v-model="info.cloudIll.doctoradvice"
      show-word-limit
      type="textarea"
      placeholder="请输入"
    >
    </van-field> -->
    <!-- <template v-if="info.cloudIll.payStatus">
      <div class="box" v-if="info.cloudIll.visitState != 7">
        <van-button class="submit" @click="goChat">在线问诊</van-button>
        <van-button class="submit" @click="submit">提交建议</van-button>
      </div> -->
    <!--
      <van-button
        class="submit"
        type="danger"
        v-if="info.cloudIll.visitState != 7"
        style="background:#ee0a24;margin-bottom:10px"
        @click="end"
        >结束就诊</van-button
      >
      <van-button
        class="submit"
        type="primary"
        v-else
        style="margin-bottom:10px"
        @click="goChat"
        >查看问诊记录</van-button
      >
    </template> -->
  </div>
</template>

<script>
import { Cell, Panel, Image, ImagePreview, Field, Button } from 'vant';
import { commonAjax,serviceUrl } from '../common/js/api';
import grkQuestionView from "@/components/cloudRegGrkQuestionView.vue";
import childQuestionView from "@/components/cloudRegChildQuestionView.vue";
import puffQuestionView from "@/components/cloudRegPuffQuestionView.vue";
import obstetricsQuestionView from "@/components/cloudRegObstetricsQuestionView.vue";
import {decryptedDES} from "@/common/js/DES";

export default {
  async mounted() {
    this.info = await commonAjax(
      '/api/authex/hpass/cloudClinic/getIllInfoByRegid',
      {
        regid: this.$route.query.regId,
      }
    );

    this.getQuestionDetail();
  },

  data() {
    return {
      suggest: '',
      errMsg: '',
      serviceUrl:serviceUrl,
      info: {
        cloudIll: {},
      },
      mzksdm:'',
      grkQuestion:{
        visitAimList: [],
        visitAim:'',
        visitAimName:'',
        visitOtherDescribe: "",
        baseIlldTypeList: [],
        baseIlldType: "",
        baseIlldOther: "",
      /*  otherIlldDescribe: "",
        illdFindTime: "",
        illdFindTimeSelect:'周前',
        otherIlldDescribeMsg:'',*/
        mzksdm:'',
        mzksmc:'',
      },
      childQuestion:{
        sex:'',
        age:'',
        isTest: "",
        weight: "",
        height: "",
        feedWayList:[],
        feedWay:'',
        feedWayName:'',
        milkYield:'',
        isAuxiliaryFood:'',
        supplementingFoodList:[],
        supplementingFood:'',
        supplementingFoodOther:'',
      /*  otherIlldDescribe: "",
        otherIlldDescribeMsg:'',
        illdDate:'',*/
        isSleep:'',
    /*    isOtherIlldDescribe:'',*/
        mzksdm:localStorage.mzksdm
      },
      puffQuestion:{
        isHot:'',
        hotDays:'',
        maxTemperature:'',
        temperature:'',
        isCold:'',
        coldDays:'',
        isCough:'',
        coughDays:'',
        isExpectoration:'',
        expectorationDays:'',
        coldTypeList:[],//感冒症状
        coldTypeName:'',//
        expectorationTypeList:[],
        expectorationTypeName:'',//咳痰颜色
        isMedication:'',//是否用过药
        medicationName:'',//用药名称
        medicationDays:'',//用药天数
        medicationEffectList:[],//用药效果
        medicationEffectName:'',//用药效果
        isAllergy:'',//请问您以前有/没有(什么)药物过敏
        allergyMedicationName:'',//药物过敏名称
        mensesDate:'',//育龄期妇女,经期时间
        baseIlldTypeList: [],
        baseIlldTypeName:'',
        baseIlldType: "",
        baseIlldOther: "",
   /*     otherIlldDescribe: "",
        otherIlldDescribeMsg:'',*/
        mzksdm:localStorage.mzksdm
      },
      obstetricsQuestion:
          {
            pregnancy:'',//目前的孕周
            pregnantMove:'',//胎动异常：1.增多;2.减少;3.消失
            pregnantRed:'',//1.量多鲜红2.少量暗红
            vaginaStream:'',//1.量多.量少
            visitOtherDescribe:'',//其他原因
            birthHistoryList:[],//生育史
            birthHistoryName:'',//生育史
            isPrenatalExamination:'',//是否产检建卡
            lastPrenatalExaminaDate:'',//最近一次产检日期
            mzksdm:'',
            mzksmc:'',
          }
    };
  },

  methods: {
    goChat() {
      this.$router.push({
        path: '/chat',
        query: {
          type: 0,
          regId: this.info.cloudIll.regId,
        },
      });
    },
    showImg(k) {
      console.log(k);
      ImagePreview({
        images: this.info.list.map(
          (item) =>
            `${serviceUrl}/api/authex/cloudClinic/loadImageFile?orgId=15&userId=${this.info.cloudIll.regUserId}&fileId=${item.fileId}`
        ),
        startPosition: k,
      });
    },
    submit() {
      commonAjax('/api/authex/hpass/cloudClinic/saveDoctorAdvice', {
        doctoradvice: this.info.cloudIll.doctoradvice,
        regRecordId: this.$route.query.regId,
      }).then((res) => {
        this.$toast('建议提交成功');
      });
    },
    async end() {
      commonAjax('/api/authex/hpass/cloudClinic/theEnd', {
        regid: this.$route.query.regId,
        endStatus: 1,
      }).then(async (res) => {
        this.$toast('结束就诊');
        this.info = await commonAjax(
          '/api/authex/hpass/cloudClinic/getIllInfoByRegid',
          {
            regid: this.$route.query.regId,
          }
        );
        this.$forceUpdate();
      });
    },
    async getQuestionDetail() {
      let basicData = await commonAjax(
          "/api/authex/hpass/cloudClinic/getRegRecordByRegId",
          {
            regId:this.$route.query.regId,
          }
      );
      this.mzksdm=basicData.localDeptId;
      console.info(basicData);
      if(this.mzksdm==4178){
        //产科
        this.obstetricsQuestion.pregnancy=basicData.cloudRegRecordQuestion.pregnancy;//目前的孕周
        this.obstetricsQuestion.pregnantMove=basicData.cloudRegRecordQuestion.pregnantMove;//胎动异常：1.增多;2.减少;3.消失
        this.obstetricsQuestion.pregnantRed=basicData.cloudRegRecordQuestion.pregnantRed;//有无见红 1.量多鲜红2.少量暗红
        this.obstetricsQuestion.vaginaStream=basicData.cloudRegRecordQuestion.vaginaStream;//有无阴道流水:1.量多;2.量少
        this.obstetricsQuestion.visitOtherDescribe=basicData.cloudRegRecordQuestion.visitOtherDescribe;//其它原因
        this.obstetricsQuestion.birthHistoryName=basicData.cloudRegRecordQuestion.birthHistoryName;//List.join(',')||'';//生育史
        this.obstetricsQuestion.isPrenatalExamination=basicData.cloudRegRecordQuestion.isPrenatalExamination;//是否产检建卡
        this.obstetricsQuestion.lastPrenatalExaminaDate=basicData.cloudRegRecordQuestion.lastPrenatalExaminaDate;//最近一次产检日期
        this.obstetricsQuestion.mzksdm=basicData.localDeptId;
        this.obstetricsQuestion.mzksmc=basicData.localDeptName;
      } else if(this.mzksdm==108||this.mzksdm==145){
        //感染科 肿瘤科
        this.grkQuestion.mzksdm=basicData.localDeptId;
        this.grkQuestion.mzksmc=basicData.localDeptName;
        let question=basicData.cloudRegRecordQuestion;
        this.grkQuestion.visitAimName=question.visitAimName;
        this.grkQuestion.visitOtherDescribe=question.visitOtherDescribe;
        this.grkQuestion.baseIlldTypeName=question.baseIlldTypeName;
        this.grkQuestion.baseIlldOther = question.baseIlldOther
       /* this.grkQuestion.illdFindTime=question.illdFindTime;
        this.grkQuestion.otherIlldDescribe=question.otherIlldDescribe;*/
      }else if(this.mzksdm==4152){
        //儿科保健
        this.childQuestion.mzksdm=basicData.localDeptId;
        this.childQuestion.mzksmc=basicData.localDeptName;
        let question=basicData.cloudRegRecordQuestion;
        this.childQuestion.sex=question.sex;
        this.childQuestion.age=question.age;
        this.childQuestion.isTest=question.isTest;
        this.childQuestion.weight=question.weight;
        this.childQuestion.height=question.height;
        this.childQuestion.feedWayName=question.feedWayName;
        this.childQuestion.milkYield=question.milkYield;
        this.childQuestion.isAuxiliaryFood=question.isAuxiliaryFood;
        this.childQuestion.isSleep=question.isSleep;
        this.childQuestion.supplementingFoodName=question.supplementingFoodName;
        this.childQuestion.supplementingFoodOther=question.supplementingFoodOther;
        this.childQuestion.illdDate=question.illdDate;
        this.childQuestion.otherIlldDescribe=question.otherIlldDescribe;

      }else if(this.mzksdm==141){
        //呼吸科
        this.puffQuestion.mzksdm=basicData.localDeptId;
        this.puffQuestion.mzksmc=basicData.localDeptName;
        let question=basicData.cloudRegRecordQuestion;
        //呼吸科问卷
        this.puffQuestion.isHot=question.isHot;
        this.puffQuestion.hotDays=question.hotDays;
        this.puffQuestion.maxTemperature=question.maxTemperature;
        this.puffQuestion.temperature=question.temperature;
        this.puffQuestion.isCold=question.isCold;
        this.puffQuestion.coldDays=question.coldDays;
        this.puffQuestion.isCough=question.isCough;
        this.puffQuestion.coughDays=question.coughDays;
        this.puffQuestion.isExpectoration=question.isExpectoration;
        this.puffQuestion.expectorationDays=question.expectorationDays;
        this.puffQuestion.coldTypeName=question.coldTypeName;//感冒症状
        this.puffQuestion.expectorationTypeName=question.expectorationTypeName;//咳痰颜色
        this.puffQuestion.isMedication=question.isMedication;//是否用过药
        this.puffQuestion.medicationName=question.medicationName;//用药名称
        this.puffQuestion.medicationDays=question.medicationDays;//用药天数
        this.puffQuestion.medicationEffectName=question.medicationEffectName;//用药效果
        this.puffQuestion.isAllergy=question.isAllergy;//请问您以前有/没有(什么)药物过敏
        this.puffQuestion.allergyMedicationName=question.allergyMedicationName;//药物过敏名称
        this.puffQuestion.mensesDate=question.mensesDate;//育龄期妇女,经期时间
        this.puffQuestion.baseIlldTypeName=question.baseIlldTypeName;
        this.puffQuestion.baseIlldOther=question.baseIlldOther;
        this.puffQuestion.otherIlldDescribe=question.otherIlldDescribe;
      }

    },
  },

  components: {
    [Cell.name]: Cell,
    [Panel.name]: Panel,
    [Image.name]: Image,
    [Field.name]: Field,
    [Button.name]: Button,
    grkQuestionView,
    childQuestionView,
    puffQuestionView,
    obstetricsQuestionView
  },

  computed: {},
};
</script>
<style lang="scss" scoped>
/*.value {
  color: #333;
}*/
.title {
  color: #666;
}
.imgs {
  padding-top: 35px;
  background: #fff;
  padding-left: 24px;
  padding-right: 24px;
  display: flex;
  // justify-content: space-between;
  align-items: center;
  align-content: center;
  flex-wrap: wrap;
  .imgBox {
    width: 204px;
    height: 204px;
    margin-right: 24px;
    margin-bottom: 20px;
    position: relative;
    &:nth-child(3n + 3) {
      margin-right: 0;
    }
    // .del {
    //   position: absolute;
    //   right: 10px;
    //   top: 10px;
    // }
    .img {
      width: 100%;
      height: 100%;
      position: relative;
      .remove {
        right: 4px;
        top: 4px;
        width: 40px;
        height: 40px;
        z-index: 999;
        position: absolute;
      }
      .img1 {
        width: 100%;
        height: 100%;
      }
    }
  }
}
.box {
  width: 670px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  .submit {
    width: 300px;
    height: 88px;
    margin: 0;
    margin-top: 24px;
  }
}
.submit {
  box-sizing: border-box;
  width: 670px;
  height: 98px;
  background: #00aac6;
  color: #fff;
  font-size: 15px;
  margin: 0 auto;
  display: block;
  margin-top: 24px;
  border-radius: 50px;
}
.value{
  color: #333;
  font-weight: bold;
  font-size: 14px;
}
.van-cell__value--alone {
  color: #333;
  font-weight: bold;
  font-size: 14px;
}

</style>
